export const recoverPassword = (payload: { phone: string }) => ({
    type: '@saga/RECOVER_PASSWORD',
    payload,
});
